import type { FunctionComponent } from "react";

import { SocialMedia } from "scmp-app/components/footer/social-media/enums";

import { InstagramUrl } from "./consts";
import InstagramIcon from "./icon-instagram.svg";
import { Container, IconContainer } from "./styles";

type Props = {
  className?: string;
};

export const PostMagazineSocialMedia: FunctionComponent<Props> = ({ className }) => {
  const socialMediaMap = {
    [SocialMedia.Instagram]: {
      icon: InstagramIcon,
      url: InstagramUrl,
    },
  };

  const renderIcon = (media: keyof typeof socialMediaMap) => {
    const { icon: Component, url } = socialMediaMap[media];
    return (
      <IconContainer key={media}>
        <a href={url} rel="noopener noreferrer" target="_blank">
          <Component />
        </a>
      </IconContainer>
    );
  };

  return (
    <Container className={className}>
      {([SocialMedia.Instagram] as const).map(media => renderIcon(media))}
    </Container>
  );
};

PostMagazineSocialMedia.displayName = "PostMagazineSocialMedia";
